module.exports = __webpack_public_path__ + "static/media/Theme5.75f5e201.png";